import EmployeeState from "../../Types/states/EmployeeState";

const employeeInitialState:EmployeeState = [];

export default employeeInitialState;
